import { IControlProvider } from '@ibiz-template/runtime';

/**
 * 编辑表单适配器
 *
 * @author lxm
 * @date 2022-10-25 18:10:57
 * @export
 * @class EditFormProvider
 * @implements {IControlProvider}
 */
export class EditFormProvider implements IControlProvider {
  component: string = 'IBizEditFormControl';
}
